<template>
    <div class="auth-layout">
        <header-auth/>
        <user-profile/>
        <main class="main-wrap">
            <slot/>
        </main>
        <footer-component/>
    </div>
</template>

<style scoped>
.auth-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: space-between;
    overflow: hidden;
}
.main-wrap {
    min-height: 600px;
}
</style>

<script>
import HeaderAuth from "../HeaderAuth";
import UserProfile from "../UserProfile";
import FooterComponent from "../FooterComponent"

export default {
    components: {
        HeaderAuth,
        UserProfile,
        FooterComponent
    }
}
</script>
